module.exports = __webpack_public_path__ + "static/media/cms7.11de3b68.png";